<template>
  <div>
    <div class="d-flex align-center">
      <v-menu offset-y open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            class="font-15 font-weight-medium cursor-help mr-2"
            v-text="`${pedidos.length} pedido${pedidos.length > 1 ? 's' : ''}`"
          />
        </template>

        <v-list>
          <span class="font-12 text-gray-100 pl-2">Pedido{{ pedidos.length > 1 ? 's' : '' }}</span>
          <v-list-item-content v-for="pedido in pedidos" :key="pedido.idpedido" class="px-2">
            <v-list-item-title>
              <span v-text="`Pedido de número ${pedido.idpedido}`" class="font-14 font-weight-medium" />
            </v-list-item-title>

            <v-list-item-subtitle class="font-12">
              <span class="text--primary">Detalhes</span> &mdash;
              pedido aberto por
              <span class="font-weight-medium" v-text="pedido.nome_comprador" />
              em {{ pedido.data_emissao }}
              <template v-if="pedido.status === 'CT'">
                e em cotação desde {{ pedido.inicio_cotacao }}
              </template>
              com {{pedido.qtde_produtos}} produto{{ pedido.qtde_produtos > 1 ? 's' : ''}}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list>
      </v-menu>

      <v-badge color="white" overlap>
        <button class="btn-red-systock py-1" @click="dialog_ativo = ! dialog_ativo">
          <v-icon class="mr-1" size="19">mdi-cart</v-icon>
          Carrinho
        </button>

        <template #badge>
          <v-progress-circular
            v-if="carregando_dados"
            indeterminate
            color="red"
            size="16"
            width="1.2"
            class="mx-n1 mt-n2px"
          />

          <span v-else class="text-black font-11" v-text="QTDE_PRODUTOS_PEDIDOS" />
        </template>
      </v-badge>
    </div>

    <v-dialog
      v-model="dialog_ativo"
      fullscreen
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card v-if="dialog_ativo">
        <TituloCarrinhoCompraProdutosGerais
          v-model="pedido_selecionado"
          :pedidos="pedidos"
          :produtos_pedido_selecionado="produtos_pedido_selecionado"
          @fechar-dialog="dialog_ativo = ! dialog_ativo"
        />

        <ListaProdutos
          v-model="pedido_selecionado"
          :pedidos="pedidos"
          @update:produtos-pedido="produtos => produtos_pedido_selecionado = produtos"
          @excluir-pedidos-carrinho-produtos-a-comprar="buscarPedidosCompras()"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ListaProdutos from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/Index";
import TituloCarrinhoCompraProdutosGerais from "@/components/compra/ProdutosGerais/Carrinho/Titulo";
import {buscarPedidosCompras} from "@/api/compraPorProdutosGerais/Carrinho";
import {logout} from "@/helpers";

export default {
  name: "CarrinhoCompraProdutosGerais",
  components: {
    TituloCarrinhoCompraProdutosGerais,
    ListaProdutos
  },
  data: () => ({
    dialog_ativo: false,
    carregando_dados: false,
    pedido_selecionado: {},
    produtos_pedido_selecionado: [],
    pedidos: [],
  }),
  computed: {
    QTDE_PRODUTOS_PEDIDOS() {
      const callback = (a, b) => a + Number(b.qtde_produtos);
      return this.pedidos.reduce(callback, 0);
    },
    COMPRA_DISTRIBUIDA_POR_FILIAL() {
      return this.$store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'];
    },
    FILTROS_STORE() {
      return this.$store.getters['CompraProdutosGerais/getFiltros'];
    },
    CALLBACK_RECARREGAR_TABELA_PRODUTOS() {
      return this.$store.getters['CompraProdutosGerais/callbackRecarregarTabelaProdutos'];
    }
  },
  watch: {
    COMPRA_DISTRIBUIDA_POR_FILIAL() {
      this.buscarPedidosCompras();
    },
    'FILTROS_STORE.grupos': function () {
      this.buscarPedidosCompras();
    },
    'FILTROS_STORE.filiais': function () {
      this.buscarPedidosCompras();
    },
    dialog_ativo() {
      if (!this.dialog_ativo) {
        this.CALLBACK_RECARREGAR_TABELA_PRODUTOS();
      }
    }
  },
  mounted() {
    this.buscarPedidosCompras();
    this.$store.dispatch("CompraProdutosGerais/callbackRecarregarPedidosCompraCarrinho", this.buscarPedidosCompras);
  },
  methods: {
    buscarPedidosCompras() {
      this.carregando_dados = true;

      const parametros = {
        multifilial_ativo: this.COMPRA_DISTRIBUIDA_POR_FILIAL ? 'S' : 'N',
        grupos: this.FILTROS_STORE.grupos,
        filiais: this.FILTROS_STORE.filiais,
        segmentos: this.FILTROS_STORE.segmentos,
        secoes: this.FILTROS_STORE.secoes,
        fornecedores: this.FILTROS_STORE.fornecedores,
        compra_produtos_combinados_ativa: this.FILTROS_STORE.compra_produtos_combinados_ativa,
      };

      this.$store.dispatch("loading/addRequisicao",
        buscarPedidosCompras(parametros)
          .then(pedidos => {
            this.pedidos = pedidos;
            this.carregando_dados = false;
            this.atualizarPedidoSelecionado();
          })
          .catch(logout)
      );
    },
    atualizarPedidoSelecionado() {
      if (this.pedidos.length === 0) {
        this.pedido_selecionado = {};
        this.dialog_ativo = false;
        return;
      }

      const pedido_selecionado_atualizado = this.pedidos.find(pedido => `${pedido.idpedido}` === `${this.pedido_selecionado.idpedido}`)

      if (pedido_selecionado_atualizado) {
        this.pedido_selecionado = pedido_selecionado_atualizado;
      }
    }
  }
}
</script>

<style scoped>
</style>
